// Course model based on API::V1::BadgeAssertionSerializer
export default {
  // Attributes
  accepted: false,
  badge_url: null,
  badge_image: null,
  badge_assertion_sso_url: null
}
